import { Component, OnInit } from '@angular/core';
import { ShiprocketService } from './shiprocket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'zeroarmario';

  constructor( private ship: ShiprocketService ){}


  ngOnInit(): void {
    this.ship.login()
  }
}
